import React, { useEffect, useState } from "react";
import { useRouteError } from "react-router-dom";
import errors from "../services/errors";

export default function ErrorPage() {
  const [errorId, setErrorId] = useState(null);
  const error = useRouteError();
  useEffect(() => {
    console.error(error);
    errors.report(error).then((id) => setErrorId(id));
  }, [error]);

  return (
    <div className="mt-24 flex flex-col h-96 justify-around text-center">
      <h1 className="text-3xl bold">Oops!</h1>
      <p className="text-base bold">
        Sorry, an unexpected error has occurred.
        <br />
        Please send a screenshot of this page to{" "}
        <a href="mailto:support@mysnowscape.com">support@mysnowscape.com</a>.
        Make sure to include the ErrorId below if there is one.
      </p>
      <p>Error ID: {errorId}</p>
      <p className="text-base bold">
        <i>{error.statusText || error.message}</i>
      </p>
      <button
        onClick={() => {
          window.location.reload();
        }}
        style={{
          alignSelf: "center",
          padding: "10px",
          backgroundColor: "#385d78",
          color: "white",
          borderRadius: "5px",
          fontWeight: "bold",
          cursor: "pointer",
        }}
      >
        Refresh Page
      </button>
      <p>
        Or try going back to the{" "}
        <a className="cursor-pointer underline" href="/admin/">
          dashboard
        </a>
      </p>
    </div>
  );
}
